/**
 * ONDATA 2 P1c — allarme rosso forte per overstay >= 24h.
 *
 * Mostrato in RoomDetailDrawer (/camere) e RoomDetailPanel (dashboard)
 * quando un booking checked_in ha sforato end_at di almeno 1 giorno.
 * Quando il cap del contatore ore extra e' raggiunto (HM_OVERSTAY_MAX_CYCLES
 * = 3 cicli da 24h, quindi deducibile lato client come overstayDays > 3
 * senza campi nuovi dal server) aggiunge la riga 'CONTATORE FERMO': gli
 * addebiti extra NON crescono piu', serve chiudere il soggiorno.
 *
 * Palette rossa "guasto" del design system (#A8453A) ma invertita
 * (testo bianco su fondo rosso) per gravita' massima.
 */
import { TriangleAlert } from '@hotel-manager/ui/icons';

export function OverstayAlert({ days }: { days: number }) {
  if (days < 1) return null;
  const capReached = days > 3;
  return (
    <div
      data-testid="overstay-alert"
      role="alert"
      className="my-2 rounded-lg bg-[#A8453A] text-white px-3 py-2.5 flex items-start gap-2"
    >
      <TriangleAlert size={18} strokeWidth={2} className="shrink-0 mt-px" />
      <div className="min-w-0">
        <div className="text-[12px] font-bold uppercase tracking-[0.4px]">
          OVERSTAY: {days} {days === 1 ? 'giorno' : 'giorni'} oltre la scadenza
        </div>
        {capReached && (
          <div
            data-testid="overstay-cap"
            className="text-[11px] font-semibold mt-0.5 text-[#FBEEEC]"
          >
            CONTATORE FERMO — gli addebiti extra sono bloccati: chiudere il soggiorno con Check-out
          </div>
        )}
      </div>
    </div>
  );
}
